import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "26",
      height: "2",
      x: "9.414",
      y: "8.383",
      fill: "#121212",
      rx: "1",
      transform: "rotate(45 9.414 8.383)"
    }, null, -1),
    _createElementVNode("rect", {
      width: "26",
      height: "2",
      x: "8.102",
      y: "26.383",
      fill: "#121212",
      rx: "1",
      transform: "rotate(-45 8.102 26.383)"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "close"}) } }